export default {
    url: '/free?page&keyword&metaSearch&questionPoolId&categoryId&createdBy&sort&externalId',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/forms/questions/poolless/index.js